import React, { Component } from 'react';
import { connect } from 'react-redux';

import Slider from 'rc-slider';
import moment from 'moment';


import { updateDates } from '../../FilterActions';

class DateSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      min: 0,
      max: 0
    };
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dates.singleDate !== this.props.dates.singleDate) {
      const diff = moment(this.props.dates.singleDate).diff(this.props.dates.startDate, 'days');
      const max = moment(this.props.dates.endDate).diff(this.props.dates.startDate, 'days');
      this.setState({
        max,
        value: diff
      });
    }
    if (prevProps.hash !== this.props.hash) {
      this.reset();
    }
  }

  reset() {
    this.props.updateValue({
      ...this.props.dates,
      singleDate: moment(this.props.dates.endDate),
      daysFromStart: moment(this.props.dates.endDate).diff(this.props.dates.startDate, 'days')
    });
  }

  updateState() {
    const diff = moment(this.props.dates.endDate).diff(this.props.dates.startDate, 'days');
    this.setState({
      value: diff,
      max: diff
    });
  }

  handleChange = e => {
    this.setState({ value: e });
  };

  handleAfterChange = e => {
    this.props.updateValue({
      ...this.props.dates,
      singleDate: moment(this.props.dates.startDate).add(e, 'days'),
      daysFromStart: e
    });
  };

  decrease = () => {
    let value = this.state.value - 1;
    if (value < this.state.min) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  increase = () => {
    let value = this.state.value + 1;
    if (value > this.state.max) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  render() {
    return (
      <div className="data-slider" style={{ padding: '0px 15px 1px 40px' }}>
        <div className="data-slider-container">
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.min}
            onClick={this.decrease}
          >
            <i className="fa fa-chevron-left glyphicon glyphicon-chevron-left"></i>
          </button>
          <Slider
            min={this.state.min}
            max={this.state.max}
            value={this.state.value}
            onChange={this.handleChange}
            onAfterChange={this.handleAfterChange}
          />
          
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.max}
            onClick={this.increase}
          >
            <i className="fa fa-chevron-right glyphicon glyphicon-chevron-right"></i>
          </button>
        </div>
        {/*<div className="data-slider-container">
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.min}
            onClick={this.decrease}
          >
            <i className="fa fa-chevron-left glyphicon glyphicon-chevron-left"></i>
          </button>
          
          <Form.Range  
            min={this.state.min}
            max={this.state.max}
            value={this.state.value}
            onChange={this.handleChange}
          />
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.max}
            onClick={this.increase}
          >
            <i className="fa fa-chevron-right glyphicon glyphicon-chevron-right"></i>
          </button>
        </div>*/}
        <p className="date-lbl">
          {moment(this.props.dates.startDate)
            .add(this.state.value, 'days')
            .format(this.props.format)}
        </p>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateValue: val => dispatch(updateDates(val, true))
  };
};

const mapStateToProps = state => {
  const chart = state.filters.chart;
  return {
    format: state.filters.dateFormat,
    dates: state.filters.dates,
    hash: state.filters[chart].hash
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(DateSlider);
export { connected as DateSlider };
